export const initialState = {
  therapistsByClinic: []
};
